/** Visual tone of the DoBox card's AgentBand. When the band is fed by a delegation, the
 *  tone comes from the run view's own tone (`resolveRunViewState`), so it never differs
 *  from the header chip or the run screen. */
export enum AgentBandTone {
  WORKING = 'WORKING',
  NEEDS_YOU = 'NEEDS_YOU',
  REVIEW = 'REVIEW',
  FAILED = 'FAILED',
}
